import type { Drilldown } from '@data/main';
import { useState } from 'react';

export function useResetTableOnFilterChange(
  drilldown: Drilldown,
  classIdsKey: string,
  studentIdsKey: string,
  reset: () => void
) {
  const [prevDrilldown, setPrevDrilldown] = useState(drilldown);
  const [prevClassIdsKey, setPrevClassIdsKey] = useState(classIdsKey);
  const [prevStudentIdsKey, setPrevStudentIdsKey] = useState(studentIdsKey);

  if (
    drilldown !== prevDrilldown ||
    classIdsKey !== prevClassIdsKey ||
    studentIdsKey !== prevStudentIdsKey
  ) {
    setPrevDrilldown(drilldown);
    setPrevClassIdsKey(classIdsKey);
    setPrevStudentIdsKey(studentIdsKey);
    reset();
  }
}
